<!--
 * @Author: Hyman Choi
 * @Date: 2020-06-15 09:54:48
 * @LastEditTime: 2020-12-28 10:29:36
 * @LastEditors: Hyman Choi
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\views\userSetting\modifyPassword\index.vue
-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-button size="small" type="primary" @click.stop="goBack()">
        返回
      </el-button>
    </el-card>

    <el-card class="box-card">
      <el-form
              :model="resetForm"
              :rules="resetFormRules"
              ref="resetForm"
              label-width="120px"
              style="margin-top: 20px"
      >
        <el-form-item label="原密码" prop="rawPwd">
          <el-input type="password" v-model="resetForm.rawPwd" auto-complete="off" style="width: 350px" prefix-icon="el-icon-lock" show-password/>
         </el-form-item>
        <el-form-item label="新密码" prop="newPwd">
          <el-input type="password" v-model="resetForm.newPwd" auto-complete="off" style="width: 350px" prefix-icon="el-icon-lock" show-password/>
            </el-form-item>
        <el-form-item label="确认密码" prop="checkPwd">
          <el-input type="password" v-model="resetForm.checkPwd" auto-complete="off" style="width: 350px" prefix-icon="el-icon-lock" show-password/>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click.native.prevent="toAmend" type="primary"> 确认修改 </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  import md5 from "js-md5";
  import storage from "good-storage";
  import {USER_KEY} from "../../../assets/constant";
  import {modifyUserPassword} from "@/api/userDetail";

export default {
  data() {
    const validateNewPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入新密码"));
      } else if (value.toString().length < 6) {
        callback(new Error("密码长度至少6位"));
      } else if (value === this.resetForm.rawPwd && this.resetForm.rawPwd.length>0){
        callback(new Error("新旧密码输入一致，请重新输入"));
      }
      else {
        callback();
      }
    };
    const validateCheckPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.resetForm.newPwd) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      resetForm: {
        //传给后台所需要的参数
        newPwd: "",
        rawPwd: "",
        userId: "", //此处只是后台需要的字段而已，如果前期有公用cookie里面有获取并且保存过，现在需要另外调用进来，具体的获取方法就看个人了
      },
      resetFormRules: {
        rawPwd: [
          { required: true, message: "请输入旧密码", trigger: 'blur' }
        ],
        newPwd: [
          { required: true, validator: validateNewPwd, trigger: 'blur' }
        ],
        checkPwd: [
          { required: true, validator: validateCheckPwd, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    //回退
    goBack() {
      this.$router.go(-1)
    },
    //修改密码
    toAmend() {
      this.$refs.resetForm.validate(valid => {
        if (valid) {
          const resetForm = _.cloneDeep(this.resetForm);
          const userData = storage.get(USER_KEY);
          resetForm.oldPassword = md5(resetForm.rawPwd);
          resetForm.newPassword = md5(resetForm.newPwd);
          resetForm.userID =userData.UserID;
          modifyUserPassword(resetForm).then((res) => {
            console.log(res);
            if (res.isError === false) {
              this.$message({message:'修改成功',type:'success',center:true,duration: '1500'}).then(this.goBack());
            }
            else {
              this.$message({
                message:res.errorMessage,
                type:'error',
                duration: '1500'});
              return false;
            }
          })
          .catch(() => {});
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
</style>
